import React from "react";
import PageHeading from "../../components/PageHeading";
import CategoryForm from "../../components/Forms/CategoryForm";
import * as Yup from "yup";
import { imageFormat, imageSize } from "../../utils/functions";
import categoryServices from "../../services/categories";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "react-query";
import { useDispatch } from "react-redux";
import { getCategories } from "../../redux/slicers/config";

const initialValues = {
  name_ar: "",
  name_en: "",
  img: "",
};

const validationSchema = Yup.object().shape({
  name_ar: Yup.string().required("هذا الحقل مطلوب"),
  name_en: Yup.string().required("هذا الحقل مطلوب"),
  img: Yup.mixed()
    .test("image-format", "يرجى تحميل صورة", (value) => {
      return value ? imageFormat.includes(value.type.split("/")[1]) : false;
    })
    .test("img-size", "حجم الصورة لايجب ان يتجاوز 5mb", (value) => {
      return value ? imageSize >= value.size : false;
    }),
});
const AddCategory = ({ title }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const onSubmit = (values, { setSubmitting }) => {
    const formData = new FormData();
    formData.append("name_ar", values.name_ar);
    formData.append("name_en", values.name_en);
    formData.append("img", values.img);

    categoryServices
      .addCategory(formData)
      .then((res) => {
        toast.success("تمت الاضافة بنجاح");
        queryClient.refetchQueries("getCategories");
        dispatch(getCategories());
        setTimeout(() => {
          navigate("/categories");
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
        toast.error("فشلت الاضافة");
        setTimeout(() => {
          setSubmitting(false);
        }, 1500);
      });
  };
  return (
    <div>
      <PageHeading>{title}</PageHeading>
      <CategoryForm
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        initialValues={initialValues}
        btnText="اضافة قسم"
      />
    </div>
  );
};

export default AddCategory;
